<template>
    <div>
        <UserNavigation/>
        <div class="container">
            <div class="row">
                <div class="col-sm">
                    <div class="card-body">
                        <form class="default-form" @submit="createOrder" novalidate>

                            <div class="form-row">
                                <div class="col">
                                    <label for="firstNameInput">Ime</label>
                                    <input id="firstNameInput" class="form-control" type="text" placeholder="Ime" v-model="firstName"/>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <label for="lastNameInput">Prezime</label>
                                        <input id="lastNameInput" class="form-control" type="text" placeholder="Prezime" v-model="lastName"/>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label for="cityInput">Grad</label>
                                        <input id="cityInput" class="form-control" type="text" placeholder="Grad" v-model="city"/>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        <label for="addressInput">Adresa</label>
                                        <input id="addressInput" class="form-control" type="text" placeholder="Adresa" v-model="address"/>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="apartmentInput">Sprat / Stan / Ostalo</label>
                                <input id="apartmentInput" class="form-control" type="text" placeholder="Sprat / Stan / Ostalo" v-model="apartment"/>
                            </div>

                            <div class="form-row">
                                <div class="col">
                                    <label for="emailInput">Email</label>
                                    <input id="emailInput" class="form-control" type="email" placeholder="Email" v-model="email"/>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <label for="phoneInput">Telefon</label>
                                        <input id="phoneInput" class="form-control" type="text" placeholder="Telefon (060 1234567)" v-model="phone"/>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="noteInput">Napomena</label>
                                <textarea id="noteInput" class="form-control" placeholder="Napomena" rows="5" v-model="note"/>
                            </div>

                            <p v-if="isProcessing">Zahtev je poslat, molimo sačekajte</p>
                            <div v-else class="button-row">
                                <button type="submit" class='btn btn-outline-secondary checkout-button'>Naruči</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import UserNavigation from '@/component/user/UserNavigation'

export default {
        name: 'Checkout',
        components: {
            UserNavigation
        },
        data() {
            return {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                city: '',
                address: '',
                apartment: '',
                note: '',
                isProcessing: false
            }
        },
        computed: {
            ...mapGetters([
                'getCartItems',
                'getTotalPriceWithShipping',
                'getTotalPrice',
                'getShippingCost'
            ]),

            items: {
                get() {
                    const items = []

                    for (const cartItem of this.getCartItems) {
                        const item = {
                            id: cartItem.id,
                            name: cartItem.name,
                            description: cartItem.description,
                            imageUrl: cartItem.imageUrl,
                            discount: cartItem.discount,
                            price: cartItem.price,
                            amountInStock: cartItem.amountInStock,
                            available: cartItem.available
                        }

                        for (let i = 0; i < cartItem.amountOrdered; i++)
                            items.push(item)
                    }

                    return items
                }
            },

            formattedSmells: {
                get() {
                    const smellLines = []
                    
                    // Group cart items by name and smell combination
                    const smellGroups = {}
                    

                    
                    for (const cartItem of this.getCartItems) {
                        if (cartItem.selectedSmell) {
                            // Create a unique key for each name-smell combination
                            const key = `${cartItem.name}-${cartItem.selectedSmell.name}`
                            

                            
                            if (!smellGroups[key]) {
                                smellGroups[key] = {
                                    name: cartItem.name,
                                    smell: cartItem.selectedSmell.name,
                                    quantity: 0
                                }
                            }
                            
                            // Add the quantity for this specific name-smell combination
                            smellGroups[key].quantity += cartItem.amountOrdered
                            

                        }
                    }
                    

                    
                    // Format each group - each name-smell combination gets its own line
                    for (const key in smellGroups) {
                        const group = smellGroups[key]
                        if (group.quantity === 1) {
                            smellLines.push(`${group.name} - ${group.smell}`)
                        } else {
                            smellLines.push(`${group.quantity}x ${group.name} - ${group.smell}`)
                        }
                    }
                    

                    return smellLines.join('\n')
                }
            }
        },
        methods : {
            ...mapActions([
                'saveCustomerAndOrder',
                'saveOrder'
            ]),

            createOrder(e) {
                e.preventDefault()
                if (this.isFormValid()) {
                    this.isProcessing = true
                    this.saveCustomerAndOrder({
                        firstName: this.firstName,
                        lastName: this.lastName,
                        email: this.email,
                        city: this.city,
                        address: this.address,
                        apartment: this.apartment,
                        phoneNumber: this.phone,
                        order: {
                            status: 'PENDING',
                            note: this.note,
                            items: this.items,
                            totalPrice: this.getTotalPrice,
                            shippingPrice: this.getShippingCost,
                            smells: this.formattedSmells,
                            customer: {
                                firstName: this.firstName,
                                lastName: this.lastName,
                                email: this.email,
                                city: this.city,
                                address: this.address,
                                apartment: this.apartment,
                                phoneNumber: this.phone,
                            }
                        }
                    })
                }
            },

            isFormValid() {
                if (!this.firstName) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greška u pravljenju porudzbine',
                        text: 'Molimo Vas popunite polje Ime'
                    })
                    return false
                }

                if (!this.lastName) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greška u pravljenju porudzbine',
                        text: 'Molimo Vas popunite polje Prezime'
                    })
                    return false
                }

                if (!this.city) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greška u pravljenju porudzbine',
                        text: 'Molimo Vas popunite polje Grad'
                    })
                    return false
                }

                if (!this.address) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greška u pravljenju porudzbine',
                        text: 'Molimo Vas popunite polje Adresa'
                    })
                    return false
                }

                if (!this.apartment) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greška u pravljenju porudzbine',
                        text: 'Molimo Vas popunite polje Sprat / Stan / Ostalo'
                    })
                    return false
                }


                if (!this.email || !this.validateEmail()) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greška u pravljenju porudzbine',
                        text: 'Molimo Vas unesite ispravnu email adresu'
                    })
                    return false
                }

                if (!this.phone || !this.validatePhone()) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greška u pravljenju porudzbine',
                        text: 'Molimo Vas unesite ispravan broj telefona!'
                    })
                    return false
                }

                return true
            },

            validateEmail() {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return re.test(String(this.email).toLowerCase())
            },

            validatePhone() {
                const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
                return re.test(String(this.phone).toLowerCase())
            }
        }
    }
</script>

<style scoped>
	* {
		background: #F0EAD6;
	}

    .button-row {
        display: flex;
        align-content: center;
        justify-content: space-between;
    }

    .checkout-button {
        background: transparent;
        color: #967bb6;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        width: 150px;
        padding: 10px;
        border: 1px solid #967bb6;
        border-radius: 0;
        cursor: pointer;
    }

    .checkout-button:hover,
    .checkout-button:active,
    .checkout-button:focus {
        background: transparent;
        border: 1px solid #6f5193 ;
        color: #6f5193 ;
    }

    .smells-preview {
        background: #ffffff;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        padding: 12px;
        margin-top: 8px;
    }

    .smells-preview pre {
        margin: 0;
        white-space: pre-wrap;
        font-family: inherit;
        font-size: 14px;
        color: #333333;
        line-height: 1.4;
    }
</style>
